import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../../components/ContactUS/ContactUs.css";
import about_pattern from "../../assests/about_pattern.svg";
import Footer from "../../components/Footer";
import AboutUsNavbar from "../../components/AboutUsNavbar";
import { Navigate } from "react-router-dom";

const DocVerificationAPI =
  "https://api-jvlands.com/api/verificationDoc/post-document";

function AboutUs() {
  const [state, setState] = useState({
    District_Tehsil: "",
    Property_Type: "",
    Name: "",
    Contact_Number: "",
    Image_Path: [],
    imagePreviews: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setState((prevState) => ({
      ...prevState,
      Image_Path: [...prevState.Image_Path, ...files],
      imagePreviews: [
        ...prevState.imagePreviews,
        ...files.map((file) => URL.createObjectURL(file)),
      ],
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const formDataToSend = new FormData();
    Object.keys(state).forEach((key) => {
      if (key === "Image_Path") {
        state[key].forEach((file, index) => {
          formDataToSend.append(`Image_Path[${index}][Image]`, file);
        });
      } else {
        formDataToSend.append(key, state[key]);
      }
    });

    try {
      const response = await axios.post(DocVerificationAPI, formDataToSend);
      if (response.data.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Document Submitted Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
        setState({
          District_Tehsil: "",
          Property_Type: "",
          Name: "",
          Contact_Number: "",
          Image_Path: [],
          imagePreviews: [],
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: "Please try again.",
      });
    }
    setIsLoading(false);
  };

  return (
    <div className="w-full h-screen">
      <AboutUsNavbar blackColor={true} activeAboutUs={true} />
      <div className="contact_us pt-16">
        <div
          id="contact_us"
          style={{
            backgroundImage: `url(${about_pattern})`,
            backgroundSize: "cover",
          }}
          className="w-full bg-[#1E1E1E] md:py-16"
        >
          <div className="w-auto md:w-1/2 m-auto bg-[#171717]">
            <form className="form p-[18px] md:p-[50px]" onSubmit={handleSubmit}>
              <p className="title">Document Verification</p>
              <label className="bg-[#333] pr-2 w-full rounded-sm">
                <select
                  className="input2"
                  name="Property_Type"
                  value={state.Property_Type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Property Type</option>
                  <option value="Plot">Plot</option>
                  <option value="House">House</option>
                  <option value="Building">Building</option>
                  <option value="Agriculture">Agriculture</option>
                </select>
                <span>Property Type</span>
              </label>
              <label>
                <input
                  className="input1"
                  type="text"
                  name="District_Tehsil"
                  value={state.District_Tehsil}
                  onChange={handleChange}
                  required
                />
                <span>City/District/Tehsil</span>
              </label>
              <label>
                <input
                  className="input1"
                  type="text"
                  name="Name"
                  value={state.Name}
                  onChange={handleChange}
                  required
                />
                <span>Name</span>
              </label>
              <label>
                <input
                  className="input1"
                  type="tel"
                  name="Contact_Number"
                  value={state.Contact_Number}
                  onChange={handleChange}
                  required
                />
                <span>Mobile</span>
              </label>
              <label>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  className="input1"
                  onChange={handleImageUpload}
                />
                <span>Upload Images</span>
              </label>
              {state.imagePreviews.length > 0 && (
                <div className="mt-4 grid grid-cols-2 gap-2">
                  {state.imagePreviews.map((src, index) => (
                    <img
                      key={index}
                      src={src}
                      alt={`Preview ${index}`}
                      className="w-full max-h-24 object-cover rounded-md"
                    />
                  ))}
                </div>
              )}
              <div className="w-full flex justify-end">
                <button className="submit" disabled={isLoading}>
                  {isLoading ? "Processing..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AboutUs;
